import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './PointsInformation.module.sass';
import ClickableDiv from '../../../../../ui_kit/clickable_div/ClickableDiv';
import learnMoreIcon from '../../../../../../images/icons/learn-more.svg';
import closeIcon from '../../../../../../images/icons/close.svg';

function PointsInformation(props) {
  const {
    price, discount = 0, className, waitlist,
  } = props;
  const [showHint, setShowHint] = useState(false);

  return (
    <div className={`${styles.points} ${className}`}>
      {`Earn ${Math.floor(price - discount)} VB points @ The Lounge`}
      <ClickableDiv
        className={styles.hint}
        onClick={() => {
          setShowHint(!showHint);
        }}
      >
        <img src={learnMoreIcon} alt="Learn More" />
      </ClickableDiv>
      { showHint && (
        <div className={styles['hint-block']}>
          <div className={styles.row}>
            <div className={styles.title}>
              THE LOUNGE LOYALTY PROGRAM
            </div>
            <ClickableDiv
              className={styles.close}
              onClick={() => {
                setShowHint(false);
              }}
            >
              <img src={closeIcon} alt="close hint" />
            </ClickableDiv>
          </div>
          <p>
            { waitlist ? 'Joining the waitlist' : 'This pre-order product' }
            {' '}
            earns you
            {' '}
            {Math.floor(price - discount)}
            {' '}
            points to redeem at The Lounge.
          </p>
          <p>
            The Lounge gives you access to discounts, free products, lab sampling,
            and so much more. Learn more about
            {' '}
            <a href="/pages/the_lounge/" target="_blank">
              The Lounge.
            </a>
          </p>
        </div>
      )}
    </div>
  );
}

PointsInformation.propTypes = {
  price: PropTypes.number.isRequired,
  discount: PropTypes.number,
  className: PropTypes.string,
  waitlist: PropTypes.bool,
};

export default PointsInformation;
